import React from 'react'
import getIcon from './icon.const'

const Icon = (icon) => {
  return <React.Fragment>{getIcon(icon)}</React.Fragment>
}
export default Icon
